import { connect } from 'react-redux'
import App from "./App";
import {toggleFullscreen} from "./actions/exam";

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.exam.loading,
    showSplashScreen: state.exam.showSplashScreen,
    showPauseScreen: state.exam.pause && process.env.REACT_APP_SHOW_PAUSESCREEN === 'true',
    fullscreen: state.exam.fullscreen,
    mode: state.exam.mode,
    type: state.exam.type
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onToggleFullscreen: () => dispatch(toggleFullscreen())
  };
};

const AppContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default AppContainer
